/**
 * Derives initials from a display name string.
 *
 * Rules:
 * - Multi-word name: first character of first word + first character of last word, uppercased
 * - Single-word name: first character of that word, uppercased
 * - Input is guaranteed non-empty by the caller
 */
export function getInitials(displayName: string): string {
  const words = displayName.trim().split(/\s+/)

  if (words.length === 1) {
    return words[0][0].toUpperCase()
  }

  const first = words[0][0]
  const last = words[words.length - 1][0]
  return (first + last).toUpperCase()
}
